export interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  category: 'interior' | 'exterior'; // Categoria da imagem: interior ou exterior
  thumbnail?: string; // Opcional: URL para uma versão em miniatura da imagem
  order: number; // Número para ordenação das imagens
}

// Array de imagens da galeria
// Para adicionar mais imagens, basta adicionar novos objetos a este array
export const GALLERY_IMAGES: GalleryImage[] = [
  // Imagens de interior da pasta assets/images/interior
  {
    id: 'sala-open-1',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-1.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 1',
    category: 'interior',
    order: 10
  },
  {
    id: 'sala-open-2',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-2.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 2',
    category: 'interior',
    order: 5
  },
  {
    id: 'sala-open-3',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-3.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 3',
    category: 'interior',
    order: 30
  },
  {
    id: 'sala-open-4',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-4.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 4',
    category: 'interior',
    order: 10
  },
  {
    id: 'sala-open-5',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-5.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 5',
    category: 'interior',
    order: 50
  },
  {
    id: 'sala-open-6',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-6.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 6',
    category: 'interior',
    order: 60
  },
  {
    id: 'sala-open-7',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-7.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 7',
    category: 'interior',
    order: 6
  },
  {
    id: 'sala-open-8',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-8.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 8',
    category: 'interior',
    order: 3
  },
  {
    id: 'sala-open-9',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/SALA-OPEN_Scene-9.effectsResult.png',
    alt: 'Sala de estar com design aberto - Vista 9',
    category: 'interior',
    order: 90
  },
  {
    id: 'suite-1',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/suite_Scene-2.effectsResult-pp.png',
    alt: 'Suíte principal - Vista 1',
    category: 'interior',
    order: 7
  },
  {
    id: 'suite-2',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/suite_Scene-3.effectsResult.png',
    alt: 'Suíte principal - Vista 2',
    category: 'interior',
    order: 8
  },
  {
    id: 'suite-3',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/suite_Scene-4.effectsResult.png',
    alt: 'Suíte principal - Vista 3',
    category: 'interior',
    order: 120
  },
  {
    id: 'suite-4',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/suite_Scene-5.effectsResult.png',
    alt: 'Suíte principal - Vista 4',
    category: 'interior',
    order: 9
  },
  {
    id: 'suite-5',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/suite_Scene-6.effectsResult.png',
    alt: 'Suíte principal - Vista 5',
    category: 'interior',
    order: 140
  },
  {
    id: 'suite-6',
    src: 'https://cdn.wave4venture.pt/assets/images/interior/suite_Scene-7.effectsResult.png',
    alt: 'Suíte principal - Vista 6',
    category: 'interior',
    order: 150
  },
  // Imagens de exterior da pasta assets/images/exterior
  {
    id: 'exterior-1',
    src: 'https://cdn.wave4venture.pt/assets/images/exterior/1.png',
    alt: 'Vista exterior da propriedade - 1',
    category: 'exterior',
    order: 200
  },
  {
    id: 'exterior-2',
    src: 'https://cdn.wave4venture.pt/assets/images/exterior/2.png',
    alt: 'Vista exterior da propriedade - 2',
    category: 'exterior',
    order: 1
  },
  {
    id: 'exterior-4',
    src: 'https://cdn.wave4venture.pt/assets/images/exterior/4.png',
    alt: 'Vista exterior da propriedade - 4',
    category: 'exterior',
    order: 220
  },
  {
    id: 'exterior-5',
    src: 'https://cdn.wave4venture.pt/assets/images/exterior/5.png',
    alt: 'Vista exterior da propriedade - 5',
    category: 'exterior',
    order: 230
  },
  {
    id: 'exterior-6',
    src: 'https://cdn.wave4venture.pt/assets/images/exterior/6.png',
    alt: 'Vista exterior da propriedade - 6',
    category: 'exterior',
    order: 2
  }
]; 